import { LevelName, WinType } from "../../abstracts/types/enums";
import { IWinLevel } from "../../abstracts/types/interfaces";
import { DDD } from "../DDD";
import { DDDSymbolNames } from "../types/DDDEnums";
import {
    AmbientSoundConfig,
    IDDDConfig,
    IDDDDevDebugSettings,
    IDDDReelAnimation,
    IDDDReelConfig,
    IDDDSymbolConfig,
    IDDDisplayConfig,
} from "../types/DDDInterfaces";

export const xbetName = `BOOSTED_BET_1`;
export const xbet2Name = `BOOSTED_BET_2`;
export const xbet3Name = `BOOSTED_BET_3`;
export const xbet3BigWinsThreeshold = 420;

export const davidPanningReelStop: number[] = [-0.25, -0.18, 0.0, 0.18, 0.25];

//timeFrame (in seconds) is used to set the time at which the sound will be played.
//for example: when game starts, the first bird sound will be played at a random time between 20 and 30 seconds.
//once the sound event was triggered, the time counter will reset and the next sound will be played
//at other random time between 20 and 30 seconds.
export const ambientalSoundSettings: AmbientSoundConfig[] = [
    {
        name: `bird`,
        timeFrame: [20, 30],
        soundsList: [
            // DDDSoundNames.AMBIENT_BIRD_01,
            // DDDSoundNames.AMBIENT_BIRD_02,
            // DDDSoundNames.AMBIENT_BIRD_03,
            // DDDSoundNames.AMBIENT_BIRD_04,
        ],
    },
    {
        name: `burp`,
        timeFrame: [80, 140],
        soundsList: [
            // DDDSoundNames.AMBIENT_BURP_01, DDDSoundNames.AMBIENT_BURP_02
        ],
    },
    {
        name: `can`,
        timeFrame: [30, 50],
        soundsList: [
            // DDDSoundNames.AMBIENT_CAN_01,
            // DDDSoundNames.AMBIENT_CAN_02,
            // DDDSoundNames.AMBIENT_CAN_03,
            // DDDSoundNames.AMBIENT_CAN_04,
        ],
    },
];

export const winLevels: IWinLevel[] = [
    { name: LevelName.TINY, winType: WinType.TINY, min: 0, max: 1, animationDuration: 0.1 },
    { name: LevelName.SMALL, winType: WinType.SMALL, min: 1, max: 3, animationDuration: 0.2 },
    { name: LevelName.MEDIUM, winType: WinType.MEDIUM, min: 3, max: 5, animationDuration: 0.66 },
    { name: LevelName.LARGE, winType: WinType.LARGE, min: 5, max: 15, animationDuration: 0.8 },
    { name: LevelName.BIG_WIN_1, winType: WinType.BIG, min: 15, max: 25, animationDuration: 2 },
    { name: LevelName.BIG_WIN_2, winType: WinType.BIG, min: 25, max: 50, animationDuration: 2.5 },
    { name: LevelName.BIG_WIN_3, winType: WinType.BIG, min: 50, max: 100, animationDuration: 3 },
    { name: LevelName.BIG_WIN_4, winType: WinType.BIG, min: 100, max: 250, animationDuration: 5 },
    { name: LevelName.BIG_WIN_5, winType: WinType.BIG, min: 250, max: 19349, animationDuration: 4 },
    {
        name: LevelName.MAX_CAP,
        winType: WinType.MAX_CAP,
        min: 19349,
        max: 20000, //not being used
        animationDuration: 6,
    },
];

export const maxWinLevel: IWinLevel = winLevels[winLevels.length - 1];

export const getWinLevel = (winMultiplier: number): IWinLevel => {
    const filteredWinLevels = winLevels.filter((level: IWinLevel) => level.min <= winMultiplier);

    const level =
        winMultiplier < 0 ? winLevels[0] : filteredWinLevels[filteredWinLevels.length - 1];

    if (
        DDD.model.buyFeatureName === xbet3Name &&
        level.winType === WinType.BIG &&
        winMultiplier < xbet3BigWinsThreeshold
    ) {
        return winLevels[3];
    }

    return level;
};

export const lowMedReelSet = [
    DDDSymbolNames.L1,
    DDDSymbolNames.L2,
    DDDSymbolNames.L3,
    DDDSymbolNames.L4,
    DDDSymbolNames.L5,
    DDDSymbolNames.M1,
    DDDSymbolNames.M2,
    DDDSymbolNames.M3,
    DDDSymbolNames.M4,
    DDDSymbolNames.M5,
];

export const normalReelSet = [...lowMedReelSet, DDDSymbolNames.SCATTER, DDDSymbolNames.WILD];

export const nudgeReelSet = [...normalReelSet, DDDSymbolNames.XN_3];
export const xGodReelSet = [...normalReelSet, DDDSymbolNames.XGOD_3];
export const allFeaturesReelSet = [...normalReelSet, DDDSymbolNames.XN_3, DDDSymbolNames.XGOD_3];

export const xGodAnticipationRepeat: number = 15;
export const xGodSymbolGenerateRepeat: number = 200;

export const symbolsArray: string[] = Object.values(DDDSymbolNames);

export const symbolConfig: IDDDSymbolConfig = {
    symbolWidth: 136,
    symbolHeight: 187,
    symbolSpacing: 0,
};

export const normalConfig: IDDDReelAnimation = {
    startEase: `circ.in`,
    startMinDelay: 0,
    startReelsDelay: 0.05,
    stopSpinReelDelay: 0.2,
    skipReelsDelay: 0.03,
    skipCurrentSymbolsTimeScale: 3,
    showNearWinAnimationDelay: 0,
    nearWinDuration: 3,
    hideNearWinDelay: 0.4,
    stepDuration: 0.02,
    stepSize: symbolConfig.symbolHeight + symbolConfig.symbolSpacing,
};

export const reelsConfig: IDDDReelConfig = {
    reelsNumber: 5,
    rowsNumber: 3,
    reelSpacing: 2,
    reelSpacingOffset: [-6, -5, -2, 3, 7],
    viewXPosition: 0,
    viewYPosition: 0,
    reelsContainerX: 16,
    reelsContainerY: 97,
    normalAnimation: normalConfig,
    stepDuration: 0.06,
    stepSize: symbolConfig.symbolHeight + symbolConfig.symbolSpacing,
    visualPaddingBefore: 1,
    paddingBefore: 0,
    visibleSymbols: 3,
    paddingAfter: 0,
    visualPaddingAfter: 1,
};

export const displayConfig: IDDDisplayConfig = {
    gameWidth: 1280,
    gameHeight: 720,
    backgroundWidth: 1680,
    backgroundHeight: 1680,
    reelsViewWidth: 720,
    reelsViewHeight: 720,
};

export const winFontSize: number = 20;
export const xNudgeFontSize: number = 24;
export const generalMultiplier: number = 6;
export const boostedName: string = `BOOSTED_BET`;

export const devDebugConfig: IDDDDevDebugSettings = {
    disableReelMask: false,
    showReelDebugGraphics: false,
    showSymbolsDebugGraphics: false,
    showSoundDebugger: false,
    showTimelineController: false,
};

export const DDDConfig: IDDDConfig = {
    reelConfig: reelsConfig,
    displayConfig: displayConfig,
    symbolConfig: symbolConfig,
    devDebugConfig: devDebugConfig,
    symbolsArray: symbolsArray,
};
